<div *ngFor="let item of alerts;" class="pAlert">
    {{ item.message | translate }}
</div>